import { Link } from "react-router-dom";

import Navbar from "./Navbar";

function Header() {
  return (
    <header className="h-14 p-4 bg-[#f5f3ef] flex justify-between items-center fixed top-0 left-0 w-full z-50 shadow">
      <Link to="/">
        <div className="w-32 flex justify-center items-center">
          <img
            src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750517657/logo-landscape-attnq_de2l3q.png"
            alt="attnq-logo-header"
          />
        </div>
      </Link>

      <Navbar />
    </header>
  );
}

export default Header;
